export default {
  namespaced: true,
  state: {
    currentPage: 1,
    totalPage: 0,
    pageSize: 10
  },

  actions: {
    setCurrentPage ({ commit }, payload) {
      commit('setCurrentPage', payload)
    },
    setTotalPage ({ commit }, payload) {
      commit('setTotalPage', payload)
    }
  },

  mutations: {
    setCurrentPage (state, payload) {
      if (payload === 'pre') { // 上一页
        state.currentPage = state.currentPage - 1
      } else if (payload === 'next') { // 下一页
        state.currentPage = state.currentPage + 1
      } else if (payload === 'first') { // 第一页
        state.currentPage = 1
      } else { // 尾页
        state.currentPage = state.totalPage
      }
    },
    setTotalPage (state, payload) {
      state.totalPage = payload
    }
  }
}
